import React from "react";
import { connect } from "react-redux";
import Sidebar from "../../components/library/Sidebar/Sidebar";
import {
  mapDispatchToPropsLayout,
  mapStateToPropsLayout,
} from "../../modules/layout";
import styled from "styled-components";

const StyledWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease;
  overflow-y: hidden;
  overflow-x: hidden;
  &.active {
    padding-left: 160px;
  }
  @media (min-width: 1025px) {
    &.sidebar-space {
      padding-left: ${(props) => (props?.isSidebarExpanded ? "160px" : "80px")};
    }
  }
  @media (max-width: 1024px) {
    padding: 0rem;
  }
`;

export const withUserNavbar = (WrappedComponent, props) => {
  const Wrapper = (props) => {
    const { route, isSidebarExpanded } = props;
    return (
      <React.Fragment>
        {props.withSidebar ? (
          <>
            <Sidebar studyId={route.study} />
            <StyledWrapper
              data-testid="with-user-navbar"
              className="sidebar-space"
              isSidebarExpanded={isSidebarExpanded}
            >
              <WrappedComponent {...props} />
            </StyledWrapper>
          </>
        ) : (
          <StyledWrapper id="content">
            <WrappedComponent {...props} />
          </StyledWrapper>
        )}
      </React.Fragment>
    );
  };

  return React.memo(
    connect(mapStateToPropsLayout, mapDispatchToPropsLayout)(Wrapper)
  );
};
